import { GetDefaultValueRangesResponse } from "@/api/types";
import { PredefinedMTTemplate } from "@/types";

export const mockPredefinedTemplates: PredefinedMTTemplate[] = [
  {
    id: 1,
    type: "pool",
    title: "Simple Pool",
    templateExplanation:
      "Basic setup for PH, ORP and temperature monitoring of a pool.",
    imgPath: "/assets/img/multitenancy-predefined-templates/simple-pool.png",
    templateDeviceValues: [
      {
        deviceType: "DACB",
        values: [
          {
            AccessLevel: 1,
            alarmrelevant: 1,
            decimals: 1,
            deviceType: "Level Sensor",
            group: "Measurements",
            mainrank: 1,
            name: "Fill Level",
            rank: 1,
            showpreview: 1,
            index: 1,
            subindex: 0,
            unit: "%",
            whitelisted: 1,
            writable: false,
            frequentlyUsedInReport: true,
            isChecked: true,
          },
          {
            AccessLevel: 2,
            alarmrelevant: 1,
            decimals: 0,
            deviceType: "Level Sensor",
            group: "Alarms",
            mainrank: 2,
            name: "Low Level Alarm",
            rank: 2,
            showpreview: 1,
            index: 2,
            subindex: 0,
            unit: "",
            whitelisted: 1,
            writable: true,
            allowManualEntry: true,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    type: "cooling-tower",
    title: "Cooling Tower",
    templateExplanation:
      "Monitor cooling towers with alarms and remote control support.",
    imgPath: "/assets/img/multitenancy-predefined-templates/cooling-tower.png",
    templateDeviceValues: [
      {
        deviceType: "GAMMAX",
        values: [
          {
            AccessLevel: 1,
            alarmrelevant: 1,
            decimals: 2,
            deviceType: "Radar Sensor",
            group: "Measurements",
            mainrank: 1,
            name: "Volume",
            rank: 1,
            showpreview: 1,
            index: 10,
            subindex: 0,
            unit: "L",
            whitelisted: 1,
            writable: false,
            frequentlyUsedInReport: true,
            isChecked: true,
          },
          {
            AccessLevel: 2,
            alarmrelevant: 0,
            decimals: 0,
            deviceType: "Radar Sensor",
            group: "Control",
            mainrank: 2,
            name: "Pump Enable",
            rank: 2,
            showpreview: 1,
            index: 20,
            subindex: 0,
            unit: "",
            whitelisted: 1,
            writable: true,
            allowManualEntry: true,
            isChecked: true,
          },
        ],
      },
      {
        deviceType: "DIALOGX",
        values: [],
      },
    ],
  },
  {
    id: 3,
    type: "dosing-application",
    title: "Dosing Application",
    templateExplanation:
      "Advanced setup with remotely controllable devices and automation variables.",
    imgPath: "/assets/img/multitenancy-predefined-templates/dosing-application.png",
    templateDeviceValues: [
      {
        deviceType: "DFXA",
        values: [
          {
            AccessLevel: 3,
            alarmrelevant: 0,
            decimals: 2,
            deviceType: "DFXA",
            group: "Performance",
            mainrank: 1,
            name: "Dosed amount [24h]",
            rank: 1,
            showpreview: 1,
            index: 24320,
            subindex: 1,
            unit: "l",
            whitelisted: 1,
            writable: false,
            frequentlyUsedInReport: true,
            isChecked: true,
          },
          {
            AccessLevel: 2,
            alarmrelevant: 0,
            decimals: 2,
            deviceType: "DFXA",
            group: "Liquid level",
            mainrank: 2,
            name: "Liquid level, percentage",
            rank: 2,
            showpreview: 1,
            index: 1000000,
            subindex: 2,
            unit: "%",
            whitelisted: 1,
            writable: false,
            frequentlyUsedInReport: true,
            isChecked: true,
          },
          {
            AccessLevel: 2,
            alarmrelevant: 0,
            decimals: 2,
            deviceType: "DFXA",
            group: "Liquid level",
            mainrank: 3,
            name: "Liquid level, volume",
            rank: 3,
            showpreview: 1,
            index: 1000000,
            subindex: 3,
            unit: "l",
            whitelisted: 1,
            writable: false,
            frequentlyUsedInReport: true,
            isChecked: true,
          },
        ],
      },
    ],
  },
];

export const mockRangesByApplication: Record<string, GetDefaultValueRangesResponse> = {
		pool: {
			ranges: {
				pH: {
					min: 6.8,
					max: 7.2,
					deviceMin: 6.5,
					deviceMax: 8.5,
					index: 20741,
					subindex: 1,
				},
				ORP: {
					min: 650,
					max: 850,
					deviceMin: 500,
					deviceMax: 900,
					index: 20742,
					subindex: 1,
				},
				temperature: {
					min: 24,
					max: 32,
				},
				chlorine: {
					min: 0.3,
					max: 1.5,
					deviceMin: 0,
					deviceMax: 3,
					index: 20743,
					subindex: 1,
				},
			},
		},

		"cooling-tower": {
			ranges: {
				pH: {
					min: 7.5,
					max: 9,
					deviceMin: 6.5,
					deviceMax: 9.5,
					index: 20741,
					subindex: 1,
				},
				conductivity: {
					min: 800,
					max: 2500,
					deviceMin: 0,
					deviceMax: 5000,
					index: 20744,
					subindex: 1,
				},
				temperature: {
					min: 20,
					max: 35,
					index: 20745,
					subindex: 1,
				},
			},
		},

		"dosing-application": {
			ranges: {
				dosedAmount24h: {
					min: 0,
					max: 500,
					deviceMin: 0,
					deviceMax: 1000,
					index: 24320,
					subindex: 1,
				},
				liquidLevelPercentage: {
					min: 0,
					max: 100,
					deviceMin: 0,
					deviceMax: 100,
					index: 1000000,
					subindex: 2,
				},
				liquidLevelVolume: {
					min: 0,
					max: 1000,
					deviceMin: 0,
					deviceMax: 2000,
					index: 1000000,
					subindex: 3,
				},
			},
		},
	};

	export const deviceOnlyRanges: GetDefaultValueRangesResponse = {
		ranges: {
			pH: {
				deviceMin: 6.5,
				deviceMax: 8.5,
				index: 20741,
				subindex: 1,
			},
			ORP: {
				index: 20742,
				subindex: 1,
			},
			chlorine: {
				deviceMin: 0,
				deviceMax: 3,
				index: 20743,
				subindex: 1,
			},
			temperature: {
				min: 24,
				max: 32,
			},
		},
	};
